const config = {
  baseApi: process.env.REACT_APP_BASE_URL,
};

export default config;
